import EnumObject from '@/domain/enum-object.entity';

export default class RuleHistory {
  id: string;

  ruleId: string;

  version: string;

  versionMajor: number;

  versionMinor: number;

  status: EnumObject;

  createdBy: string;

  createdDate: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.ruleId = obj.ruleId || '';
    this.version = obj.version || '';
    this.versionMajor = obj.versionMajor || 0;
    this.versionMinor = obj.versionMinor || 0;
    this.status = EnumObject.of(obj.status);
    this.createdBy = obj.createdBy || '';
    this.createdDate = obj.createdDate || '';
  }

  public static of(obj: any = {}): RuleHistory {
    return new RuleHistory(obj);
  }

  public static ofList(obj: any[] = []): RuleHistory[] {
    return obj.map(this.of);
  }

  get isDraft(): boolean {
    return this.status.value === 'DRAFT';
  }

  get isPublished(): boolean {
    return this.status.value === 'PUBLISHED';
  }

  get isRestored(): boolean {
    return this.status.value === 'RESTORED';
  }
}
